export const shoppingQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The woman is holding a coat in front of a mirror.",
      B: "The woman is trying on a coat.",
      C: "The woman is purchasing an item at the checkout counter.",
      D: "The woman is organizing clothes on a rack.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 거울 앞에서 코트를 들고 있음\n" +
      "오답 설명: (B) 코트를 입어보지 않음, (C) 계산대에서 물건을 구매하지 않음, (D) 옷을 정리하지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "The woman is paying at the register.",
      B: "The woman is holding a product.",
      C: "The woman is pushing a shopping cart.",
      D: "The woman is talking to a store employee.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 제품을 들고 있음\n" +
      "오답 설명: (A) 계산대에서 계산하지 않음, (C) 쇼핑 카트를 밀지 않음, (D) 직원과 대화하지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The man is paying with cash.",
      B: "The cashier is scanning an item.",
      C: "The man is picking up a product from the shelf.",
      D: "The man is packing groceries into a bag.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 장바구니에 식료품을 담고 있음\n" +
      "오답 설명: (A) 현금으로 계산하지 않음, (B) 계산원이 물건을 스캔하지 않음, (C) 선반에서 물건을 집지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The man is pushing a shopping cart.",
      B: "The man is paying at the checkout counter.",
      C: "The man is selecting vegetables from a shelf.",
      D: "The man is loading groceries into a car.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 식료품을 차에 싣고 있음\n" +
      "오답 설명: (A) 쇼핑 카트를 밀지 않음, (B) 계산대에서 계산하지 않음, (C) 채소를 고르지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "The cashier is packing groceries into a bag.",
      B: "The cashier is accepting a payment from a customer.",
      C: "The cashier is scanning items at the register.",
      D: "The cashier is arranging products on a shelf.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 계산원이 계산대에서 물건을 스캔하고 있음\n" +
      "오답 설명: (A) 물건을 포장하지 않음, (B) 고객에게서 결제를 받지 않음, (D) 선반에 물건을 정리하지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "The customer is making a payment at the checkout.",
      B: "The woman is selecting an item from a shelf.",
      C: "The cashier is scanning a product.",
      D: "The man is packing groceries into a bag.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 고객이 계산대에서 결제하고 있음\n" +
      "오답 설명: (B) 선반에서 물건을 고르지 않음, (C) 물건을 스캔하지 않음, (D) 장바구니에 물건을 담지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "The woman is putting items into a shopping cart.",
      B: "The woman is entering her payment at the register.",
      C: "The cashier is placing items on a shelf.",
      D: "The man is pushing a shopping cart toward the exit.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 계산대에서 결제를 입력하고 있음\n" +
      "오답 설명: (A) 쇼핑 카트에 물건을 담지 않음, (C) 선반에 물건을 놓지 않음, (D) 출구 쪽으로 카트를 밀지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "The woman is folding clothes on a table.",
      B: "The woman is paying for a purchase at the counter.",
      C: "The woman is browsing through garments.",
      D: "The woman is trying on a sweater in front of a mirror.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 옷을 둘러보고 있음\n" +
      "오답 설명: (A) 옷을 접지 않음, (B) 계산대에서 계산하지 않음, (D) 거울 앞에서 스웨터를 입어보지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "The woman is folding clothes on a table.",
      B: "The woman is trying on a jacket.",
      C: "The woman is carrying a bag on her shoulder.",
      D: "The woman is purchasing an item at the checkout.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 가방을 어깨에 메고 있음\n" +
      "오답 설명: (A) 옷을 접지 않음, (B) 재킷을 입어보지 않음, (D) 계산대에서 물건을 구매하지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The woman is paying at the checkout counter.",
      B: "The woman is examining a product.",
      C: "The woman is carrying a basket full of groceries.",
      D: "The woman is walking toward the entrance.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 제품을 살펴보고 있음\n" +
      "오답 설명: (A) 계산대에서 계산하지 않음, (C) 장바구니가 있지만 가득찼는지는 안보임. (D) 입구 쪽으로 걷지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "The woman is pushing a shopping cart.",
      B: "The woman is placing an item into a basket.",
      C: "The woman is reaching for a product on the top shelf.",
      D: "The woman is checking out at the register.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 높은 선반의 제품을 잡으려 하고 있음\n" +
      "오답 설명: (A) 쇼핑 카트가 없음 (B) 바구니가 이미지에 없음 (D) 계산대가 보이지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "The people are standing in line at the checkout.",
      B: "The people are carrying shopping baskets.",
      C: "The people are loading groceries into a car.",
      D: "The people are organizing products on shelves.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사람들이 쇼핑 바구니를 들고 있음\n" +
      "오답 설명: (A) 계산대에 줄을 서있지 않음, (C) 차가 보이지 않음 (D) 선반에 물건을 정리하는 모습은 없음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The man is cleaning a table.",
      B: "The barista is preparing a drink.",
      C: "The worker is serving a customer.",
      D: "The man is washing dishes.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 바리스타가 음료를 준비하고 있음\n" +
      "오답 설명: (A) 테이블을 닦고 있지 않음, (C) 손님을 응대하고 있지 않음, (D) 설거지를 하고 있지 않음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "The woman is cleaning the table.",
      B: "The woman is cooking in the kitchen.",
      C: "The waitress is carrying plates of food.",
      D: "The woman is placing a menu on the table.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 웨이트리스가 음식이 담긴 접시를 나르고 있음\n" +
      "오답 설명: (A) 테이블을 닦고 있지 않음, (B) 주방에서 요리하고 있지 않음, (D) 메뉴판을 테이블에 놓고 있지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The woman is typing on a keyboard.",
      B: "The woman is using a touchscreen.",
      C: "The woman is reading a book.",
      D: "The woman is sitting on a couch.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 터치스크린을 사용하고 있음\n" +
      "오답 설명: (A) 키보드를 사용하고 있지 않음, (C) 책을 읽고 있지 않음, (D) 소파에 앉아있지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The waitress is taking an order.",
      B: "The customers are paying for their meal.",
      C: "The waitress is serving food.",
      D: "The customers are leaving the restaurant.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 웨이트리스가 주문을 받고 있음\n" +
      "오답 설명: (B) 손님들이 식사 비용을 지불하고 있지 않음, (C) 웨이트리스가 음식을 서빙하고 있지 않음, (D) 손님들이 레스토랑을 떠나고 있지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The customer is placing an item on the counter.",
      B: "The woman is browsing through clothes.",
      C: "A shopping bag is being handed to the customer.",
      D: "The sales assistant is arranging products on a shelf.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 쇼핑백이 고객에게 건네지고 있음\n" +
      "오답 설명: (A) 고객이 물건을 카운터에 올려놓고 있지 않음, (B) 여자가 옷을 둘러보고 있지 않음, (D) 판매원이 선반에 상품을 진열하고 있지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The man is drinking coffee.",
      B: "The barista is pouring a beverage.",
      C: "The worker is cleaning a table.",
      D: "The man is writing on a notepad.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 바리스타가 음료를 따르고 있음\n" +
      "오답 설명: (A) 남자가 커피를 마시고 있지 않음, (C) 직원이 테이블을 닦고 있지 않음, (D) 남자가 메모장에 글을 쓰고 있지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The barista is making a coffee.",
      B: "The customer is handing cash to the cashier.",
      C: "A payment is being made.",
      D: "The worker is cleaning the counter.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 결제가 이루어지고 있음\n" +
      "오답 설명: (A) 바리스타가 커피를 만들고 있지 않음, (B) 고객이 캐셔에게 현금을 건네고 있지 않음, (D) 직원이 카운터를 닦고 있지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "The woman is folding clothes on a table.",
      B: "The woman is dressing a mannequin.",
      C: "The woman is altering a garment.",
      D: "The woman is taking a dress off a mannequin.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 마네킹에 옷을 입히고 있음\n" +
      "오답 설명: (A) 여자가 테이블에서 옷을 접고 있지 않음, (C) 여자가 옷을 수선하고 있지 않음, (D) 여자가 마네킹에서 드레스를 벗기고 있지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "A woman is putting a jacket on.",
      B: "A woman is looking at herself in a mirror.",
      C: "A price tag is attached to the garment.",
      D: "A woman is folding some clothes.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 옷에 가격 태그가 붙어 있음\n" +
      "오답 설명: (A) 여성이 옷을 입고 있지 않고 보고 있음, (B) 거울을 보는 장면이 아님, (D) 옷을 개는 장면이 아님",
  },
  {
    questionNumber: 22,
    choices: {
      A: "A woman is picking up an item from a shelf.",
      B: "A shop assistant is showing a product to a customer.",
      C: "A customer is paying for a purchase.",
      D: "The shelves are empty.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 점원이 고객에게 상품을 보여주고 설명하는 장면이므로 정답\n" +
      "오답 설명: (A) 고객이 물건을 집는 장면이 아니라 점원이 제품을 보여주는 중이므로 오답, (C) 결제하는 장면이 아니므로 오답, (D) 선반에는 다양한 상품이 가득 차 있으므로 오답",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A woman is browsing through clothes.",
      B: "A woman is paying for a purchase.",
      C: "A woman is folding some clothes.",
      D: "A woman is trying on a jacket.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여성이 옷을 살펴보고 있으므로 정답\n" +
      "오답 설명: (B) 결제하는 장면이 아니므로 오답, (C) 옷을 개고 있는 장면이 아니므로 오답, (D) 여성이 옷을 입어보는 것이 아니라 살펴보는 중이므로 오답",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A man is entering a store.",
      B: "A man is stepping inside a shop.",
      C: "A man is leaving the building.",
      D: "A man is walking into the store.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 문을 열고 건물을 나가는 모습이므로 정답\n" +
      "오답 설명: (A) 남자는 들어가는 것이 아니라 나가는 중이므로 오답, (B) 가게 안으로 들어가는 모습이 아니므로 오답, (D) 가게로 들어가는 장면이 아니므로 오답",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A woman is selecting a jacket from a rack.",
      B: "A woman is adjusting a dress.",
      C: "A woman is walking past a clothing store.",
      D: "A woman's reflection is visible in the mirror.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여성이 거울을 통해 자신의 모습을 보고 있으므로 정답\n" +
      "오답 설명: (A) 옷걸이에서 옷을 고르는 장면이 아니므로 오답, (B) 드레스를 정리하는 장면이 아니므로 오답, (C) 가게를 지나가는 장면이 아니므로 오답",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A man is polishing his shoes.",
      B: "A man is trying on a pair of shoes.",
      C: "A man is walking out of the store.",
      D: "A man is arranging shoes on a shelf.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 신발을 신어보고 있으므로 정답\n" +
      "오답 설명: (A) 남자가 신발을 닦는 것이 아니므로 오답, (C) 남자가 가게를 나가는 것이 아니므로 오답, (D) 남자가 신발을 정리하는 것이 아니므로 오답",
  },
  {
    questionNumber: 27,
    choices: {
      A: "A shopping bag is being handed to a woman.",
      B: "A woman is putting on a bracelet.",
      C: "A man is opening a jewelry case.",
      D: "A customer is trying on a necklace.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 쇼핑백이 여성에게 건네지고 있는 장면이므로 정답\n" +
      "오답 설명: (B) 여성이 팔찌를 착용하는 장면이 아니므로 오답, (C) 남자가 보석 상자를 여는 장면이 아니므로 오답, (D) 고객이 목걸이를 착용하는 장면이 아니므로 오답",
  },
  {
    questionNumber: 28,
    choices: {
      A: "A man is watering some plants.",
      B: "A man is arranging flowers in a vase.",
      C: "A florist is wrapping a bouquet.",
      D: "A customer is purchasing a flower arrangement.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 플로리스트가 꽃다발을 포장하고 있으므로 정답\n" +
      "오답 설명: (A) 남자가 식물에 물을 주는 장면이 아니므로 오답, (B) 꽃을 꽃병에 꽂는 장면이 아니므로 오답, (D) 고객이 꽃을 사는 장면이 아니므로 오답",
  },
  {
    questionNumber: 29,
    choices: {
      A: "A chef is preparing a meal in the kitchen.",
      B: "A waitress is serving a customer.",
      C: "A chef is passing a plate to a waitress.",
      D: "A woman is placing an order at the counter.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 주방장이 웨이트리스에게 접시를 건네고 있으므로 정답\n" +
      "오답 설명: (A) 주방장이 음식을 준비하는 장면이 아니므로 오답, (B) 웨이트리스가 손님을 응대하는 장면이 아니므로 오답, (D) 여성이 주문하는 장면이 아니므로 오답",
  },
  {
    questionNumber: 30,
    choices: {
      A: "A woman is putting items into a shopping cart.",
      B: "A man is scanning a barcode.",
      C: "A customer is receiving change from the cashier.",
      D: "A woman is making a payment.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여성이 결제를 하고 있으므로 정답\n" +
      "오답 설명: (A) 여성이 장바구니에 물건을 담는 장면이 아니므로 오답, (B) 남성이 바코드를 스캔하는 장면이 아니므로 오답, (C) 고객이 거스름돈을 받는 장면이 아니므로 오답",
  },

  {
    questionNumber: 32,
    choices: {
      A: "A woman is trying on a jacket.",
      B: "A man is folding some clothes.",
      C: "A man is viewing a suit.",
      D: "A customer is paying for a purchase.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 정장을 살펴보고 있으므로 정답\n" +
      "오답 설명: (A) 여성이 옷을 입어보는 장면이 아니므로 오답, (B) 남자가 옷을 개는 장면이 아니므로 오답, (D) 고객이 결제하는 장면이 아니므로 오답",
  },
];
